import 'babel-polyfill';
import _ from 'lodash';
import Swiper from 'swiper/dist/js/swiper';
import initSimpleCollapse from '../simpleCollapse';


function resizeHomeBottomBanner() {

    let bannerTitleMaxHeight = 0;
    const bannerTitle = $('.home-bottom-banner .banner-title');
    //remove the inline height
    bannerTitle.attr('style', '');
    //get the max height
    bannerTitle.each((i, el) => {
        el = $(el);
        bannerTitleMaxHeight = el.outerHeight() > bannerTitleMaxHeight ? el.outerHeight() : bannerTitleMaxHeight;
    });
    bannerTitle.css('height', bannerTitleMaxHeight);
}

$(document).ready(function () {

    const homeBannerSwiper = new Swiper('#home-banner-swiper-container', {
        autoHeight: true,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        speed: 2000,
        on: {
            init: function() {
                this.$el.find('img').removeClass('d-none');
            }
        }
    });

    resizeHomeBottomBanner();
    $('.home-bottom-banner img').on('load', _.debounce(resizeHomeBottomBanner, 100));
    $(window).on('resize', _.debounce(resizeHomeBottomBanner, 100));

    initSimpleCollapse();

});
